<template>
  <div class="base-set-wrap">
    <div class="card-header">
      <span class="title-text"
        >基础设置
        <span :class="showTips ? 'el-form-item__error' : 'hidden_error'" class="error-tip" v-show="showTips">请补充完基础设置</span></span
      >
      <el-button class="add-plan" type="text" @click="showDrawerBox">
        <svg-icon iconClass="edit" className="edit-btn"></svg-icon>编辑</el-button
      >
    </div>
    <div class="set-form">
      <div class="form-item">
        <span class="item-lable">广告名称：</span>
        <span class="item-value">{{ formatAdName }}</span>
      </div>
      <div class="form-item">
        <span class="item-lable">投放目标：</span>
        <span class="item-value">转化量</span>
      </div>
      <div class="form-item">
        <span class="item-lable">优化目标：</span>
        <span class="item-value">{{
          !optimizeGoal
            ? "-"
            : optimizeGoal.external_action === "AD_CONVERT_TYPE_ACTIVE"
            ? "激活"
            : optimizeGoal.external_action === "AD_CONVERT_TYPE_GAME_ADDICTION"
            ? "关键行为"
            : "-"
        }}</span>
      </div>
      <div class="form-item">
        <span class="item-lable">投放范围：</span>
        <span class="item-value">{{
          !deliveryRange ? "-" : deliveryRange.inventory_catalog === "UNIVERSAL_SMART" ? "通投智选" : "首选媒体"
        }}</span>
      </div>
      <div class="form-item" v-show="deliveryRange && deliveryRange.inventory_catalog === 'MANUAL'">
        <span class="item-lable">广告位置：</span>
        <span class="item-value">{{ !deliveryRange ? "-" : `按媒体指定位置${inventoryTypeName}` }}</span>
      </div>
    </div>
    <!-- 抽屉 -->
    <el-drawer
      title="基础设置"
      :visible.sync="showDrawer"
      size="674px"
      :show-close="false"
      class="drawer-wrap"
      @open="openDrawer"
      @closed="drawerClosed"
    >
      <edit-base-set ref="basesetRef" @closeDrawer="closeDrawer"></edit-base-set>
    </el-drawer>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import EditBaseSet from "./editBaseSet.vue";
import { mapState } from "vuex";
import nameTransforUtil from "./common/nameTransforUtil.js";
import { inventory_type_list } from "./subDirectpkg/optionData";
export default {
  components: {
    SvgIcon,
    EditBaseSet,
  },
  data() {
    return {
      showDrawer: false,
      showTips: false,
      inventory_type_list,
      formatAdName: "",
    };
  },
  methods: {
    showDrawerBox() {
      if (!this.adCount) {
        this.$alert("请选择广告账号后再操作", "提示", {
          confirmButtonText: "确定",
        });
      } else {
        this.showDrawer = true;
      }
    },
    closeDrawer() {
      this.showDrawer = false;
    },
    openDrawer() {
      //弹框打开查询表单数据
      this.$nextTick(() => {
        this.$refs.basesetRef.initFormData();
      });
    },
    async drawerClosed() {
      //保存数据到store
      await this.$refs.basesetRef.saveDataInStore();
      //数据格式校验，显示校验标识
      this.$refs.basesetRef
        .checkData()
        .then(() => {})
        .catch(() => {});
      this.checkData();
    },
    controlTips(data) {
      this.showTips = data;
    },
    async checkData() {
      return new Promise((resolve, reject) => {
        if (this.$refs.basesetRef) {
          this.$refs.basesetRef
            .checkData()
            .then(() => {
              this.controlTips(false);
              return resolve();
            })
            .catch(() => {
              this.controlTips(true);
              return reject();
            });
        } else {
          //存在广告计划名称但是组件没有挂载说明选择了模板
          if (this.formatAdName !== "-") {
            this.controlTips(false);
            return resolve();
          } else {
            this.controlTips(true);
            return reject();
          }
        }
      });
    },
  },
  watch: {
    optimizeGoal: {
      handler(val) {
        this.formatAdName = val?.ad_name ? nameTransforUtil.apiDatatoShow(val?.ad_name) : "-";
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionTtV2.baseData.advertiser_id,
      optimizeGoal: (state) => state.PromotionTtV2.optimizeGoal,
      deliveryRange: (state) => state.PromotionTtV2.deliveryRange,
    }),
    inventoryTypeName() {
      let list = [];
      this.deliveryRange.inventory_type?.map((item) => {
        const findObj = this.inventory_type_list.find((child) => child.value === item) || {};
        list.push(findObj.label);
      });
      return list.length > 0 ? `（${list.join("，")}）` : "";
    },
  },
};
</script>

<style lang="less" scoped>
.base-set-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    display: flex;
    justify-content: space-between;
    position: relative;
    .title-text {
      color: rgba(0, 0, 0, 1);
      font-size: 16px;
      font-weight: bold;
      .el-form-item__error {
        font-size: 12px;
        color: #f56c6c;
        font-weight: normal;
        top: 2px;
        left: 78px;
      }
    }
    .edit-btn {
      margin-right: 6px;
      font-size: 14px;
    }
  }
  .set-form {
    margin-top: 18px;
    .form-item {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 38px;
      .item-lable {
        display: inline-block;
        width: 100px;
      }
    }
  }
  .drawer-wrap {
    /deep/.el-drawer__header {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.95);
      font-weight: bold;
      margin-bottom: 22px;
    }
  }
}
</style>
